import { ImageSettings } from '@lessonup/pins-shared';

export function isPlaceholderImage(pinComponentSettings: ImageSettings) {
  return !pinComponentSettings.url || pinComponentSettings.url === '';
}
